export default {
  // Hero Section
  'sourcing.hero.title': '选品中心',
  'sourcing.hero.subtitle': '按产地/按场景/按资料齐全度快速选品，一键生成RFQ并匹配供应商',
  'sourcing.hero.search.placeholder': '搜索产品关键词...',
  'sourcing.hero.search.role': '采购角色',
  'sourcing.hero.search.country': '目的国',
  'sourcing.hero.chip.stock': '现货',
  'sourcing.hero.chip.mixed': '混批',
  'sourcing.hero.chip.lcl': '拼柜',
  'sourcing.hero.chip.docs': '资料齐全',
  'sourcing.hero.chip.custom': '可定制',

  // Quick Entry
  'sourcing.entry.belt.title': '按产业带选品',
  'sourcing.entry.belt.cities': '佛山 / 肇庆 / 汕尾 / 揭阳',
  'sourcing.entry.belt.tag1': '产地直采',
  'sourcing.entry.belt.tag2': '优势品类',
  'sourcing.entry.belt.tag3': '响应时效',
  'sourcing.entry.belt.cta': '进入产地视图',
  'sourcing.entry.scene.title': '按行业场景选品',
  'sourcing.entry.scene.examples': '家具五金 / 橱柜材料包 / 铝天花系统',
  'sourcing.entry.scene.tag1': 'BOM套装',
  'sourcing.entry.scene.tag2': '场景化',
  'sourcing.entry.scene.tag3': '一站式',
  'sourcing.entry.scene.cta': '进入行业场景',

  // Tabs
  'sourcing.tab.industry': '行业场景',
  'sourcing.tab.industry.desc': 'BOM/套装更强',
  'sourcing.tab.sku': 'SKU库',
  'sourcing.tab.sku.desc': '数据库检索',
  'sourcing.tab.supplier': '供应商库',
  'sourcing.tab.supplier.desc': '工厂/贸易分层',
  'sourcing.tab.rfq': '需求发布',
  'sourcing.tab.rfq.desc': 'RFQ模板',
  'sourcing.tab.custom': '柔性定制',
  'sourcing.tab.custom.desc': '打样→量产',

  // View Switcher
  'sourcing.view.scene': '场景视图',
  'sourcing.view.belt': '产地视图',

  // Buyer Type
  'sourcing.buyer.wholesale': '批发商',
  'sourcing.buyer.platform': '平台卖家',

  // Filter Bar
  'sourcing.filter.supply': '供给方式',
  'sourcing.filter.supply.all': '全部',
  'sourcing.filter.supply.stock': '现货',
  'sourcing.filter.supply.mixed': '混批',
  'sourcing.filter.supply.lcl': '拼柜',
  'sourcing.filter.supply.custom': '可定制',
  'sourcing.filter.moq': 'MOQ',
  'sourcing.filter.moq.all': '全部',
  'sourcing.filter.moq.trial': '试单（<100）',
  'sourcing.filter.moq.wholesale': '批发（100-1000）',
  'sourcing.filter.moq.bulk': '大货（>1000）',
  'sourcing.filter.leadtime': '交期',
  'sourcing.filter.leadtime.all': '全部',
  'sourcing.filter.leadtime.7': '≤7天',
  'sourcing.filter.leadtime.15': '≤15天',
  'sourcing.filter.leadtime.30': '≤30天',
  'sourcing.filter.docs': '资料齐全度',
  'sourcing.filter.docs.all': '全部',
  'sourcing.filter.docs.complete': '全部齐全',
  'sourcing.filter.docs.partial': '部分齐全',
  'sourcing.filter.docs.building': '建设中',
  'sourcing.filter.sort': '排序',
  'sourcing.filter.sort.recommended': '推荐排序',
  'sourcing.filter.sort.leadtime': '交期优先',
  'sourcing.filter.sort.docs': '资料齐全度',
  'sourcing.filter.sort.price': '价格优先',

  // SKU Card
  'sourcing.sku.moq': 'MOQ',
  'sourcing.sku.leadtime': '交期',
  'sourcing.sku.price': '价格区间',
  'sourcing.sku.supplier': '供应商',
  'sourcing.sku.docs': '资料齐全度',
  'sourcing.sku.factory': '工厂',
  'sourcing.sku.trading': '贸易',
  'sourcing.sku.addToRFQ': '加入RFQ',
  'sourcing.sku.sample': '索样',
  'sourcing.sku.detail': '查看详情',
  'sourcing.sku.days': '天',
  'sourcing.sku.pieces': '件',

  // RFQ Cart
  'sourcing.rfq.cart.title': 'RFQ 控制台',
  'sourcing.rfq.cart.items': '项',
  'sourcing.rfq.cart.empty': '暂无产品',
  'sourcing.rfq.cart.country': '目的国',
  'sourcing.rfq.cart.country.placeholder': '请选择',
  'sourcing.rfq.cart.terms': '交付条款',
  'sourcing.rfq.cart.notes': '备注（包装、贴标、资料要求）',
  'sourcing.rfq.cart.notes.placeholder': '请输入特殊要求...',
  'sourcing.rfq.cart.submit': '提交 RFQ',
  'sourcing.rfq.cart.match': '将匹配工厂/贸易商及服务包',
  'sourcing.rfq.bom.title': 'BOM 套装推荐',
  'sourcing.rfq.bom.add': '一键加入',

  // Scene Catalog
  'sourcing.scene.title': '行业场景',
  'sourcing.scene.furniture': '家具五金与配件批发',
  'sourcing.scene.cabinet': '橱柜/定制家居材料包',
  'sourcing.scene.panel': '板材饰面与封边耗材',
  'sourcing.scene.adhesive': '胶水/涂料与施工辅材',
  'sourcing.scene.plywood': '夹板/多层板与基材批发',
  'sourcing.scene.ceiling': '铝天花系统与配件',
  'sourcing.scene.platform': '平台热卖基础款',
  'sourcing.scene.mixed': '一站式混批（拼柜）',

  // Belt View
  'sourcing.belt.city': '产业带城市',
  'sourcing.belt.advantage': '优势品类',
  'sourcing.belt.capability': '城市能力',
  'sourcing.belt.response': '响应时效',
  'sourcing.belt.docs.rate': '资料齐全度',
  'sourcing.belt.countries': '覆盖国家',
  'sourcing.belt.suppliers': '供应商数',
  'sourcing.belt.stock.rate': '现货比例',
  'sourcing.belt.contact': '联系产地顾问',

  // Empty State
  'sourcing.empty.title': '暂无匹配结果',
  'sourcing.empty.desc': '试试调整筛选条件或浏览推荐场景',
  'sourcing.empty.relax': '放宽筛选条件',
  'sourcing.empty.rfq': '一键发布 RFQ',
  'sourcing.empty.recommended': '推荐场景',

  // Mobile
  'sourcing.mobile.viewRFQ': '查看 RFQ',
  'sourcing.mobile.submitRFQ': '提交 RFQ',
  'sourcing.mobile.cart.title': 'RFQ 购物车',
  'sourcing.mobile.cart.empty': '购物车为空',
  'sourcing.mobile.cart.empty.desc': '快去选品吧！',
  'sourcing.mobile.cart.selected': '已选',
  'sourcing.mobile.cart.continue': '继续选品',

  // RFQ Templates
  'sourcing.rfq.template.title': '选择 RFQ 模板',
  'sourcing.rfq.template.wholesale': '批发采购 RFQ',
  'sourcing.rfq.template.wholesale.desc': '适合批发商，关注现货/混批/拼柜/交期',
  'sourcing.rfq.template.platform': '平台选品 RFQ',
  'sourcing.rfq.template.platform.desc': '适合平台卖家，关注资料/贴标/试单MOQ',
  'sourcing.rfq.template.project': '工程单 RFQ',
  'sourcing.rfq.template.project.desc': '适合工程项目，关注定制/质量/交付',

  // RFQ Form
  'sourcing.rfq.form.step.product': '产品信息',
  'sourcing.rfq.form.step.quantity': '数量要求',
  'sourcing.rfq.form.step.delivery': '交期要求',
  'sourcing.rfq.form.step.terms': '交付条款',
  'sourcing.rfq.form.step.docs': '资料与合规',
  'sourcing.rfq.form.step.submit': '提交',
  'sourcing.rfq.form.back': '返回',
  'sourcing.rfq.form.next': '下一步',
  'sourcing.rfq.form.submit': '提交 RFQ',

  // RFQ Success
  'sourcing.rfq.success.title': 'RFQ 提交成功！',
  'sourcing.rfq.success.desc': '我们已为您匹配供应商和服务包',
  'sourcing.rfq.success.matched': '已匹配',
  'sourcing.rfq.success.suppliers': '家供应商',
  'sourcing.rfq.success.services': '推荐服务包',
  'sourcing.rfq.success.view': '查看匹配结果',
  'sourcing.rfq.success.new': '发布新 RFQ',

  // Custom Manufacturing
  'sourcing.custom.title': '柔性定制',
  'sourcing.custom.upload': '上传图纸/图片',
  'sourcing.custom.timeline': '定制流程',
  'sourcing.custom.timeline.sample': '打样',
  'sourcing.custom.timeline.confirm': '确认',
  'sourcing.custom.timeline.production': '量产',
  'sourcing.custom.timeline.qc': '质检',
  'sourcing.custom.timeline.export': '出海',
  'sourcing.custom.options': '可定制项',
  'sourcing.custom.options.size': '尺寸',
  'sourcing.custom.options.surface': '表面',
  'sourcing.custom.options.color': '颜色',
  'sourcing.custom.options.packaging': '包装贴标',
  'sourcing.custom.generate': '生成定制 RFQ'
};